import { useContext } from 'react'

import { SocketContext } from 'context'

export const useIsConnected = (): boolean => {
  const { isConnected } = useContext(SocketContext)

  return isConnected
}
